import AxiosInterceptor from "api/interceptor";
import fx from "utils/fx";

const campaigns = new AxiosInterceptor();

export default {
  get(qstr) {
    qstr = fx.urlQueryString(qstr, false);
    return campaigns.get("/campaigns?" + qstr);
  },
  delete(id) {
    return campaigns.delete("/campaigns/" + id);
  },
  create(inputs) {
    return campaigns.post("/campaigns", inputs);
  },
  find(id) {
    return campaigns.get("/campaigns/" + id);
  },
  update(id, inputs) {
    return campaigns.put("/campaigns/" + id, inputs);
  },
  sort(inputs) {
    return campaigns.post("/campaigns/sort", inputs);
  },
  addPost(inputs) {
    return campaigns.post("/campaigns/add-post", inputs);
  },
  removePost(inputs) {
    return campaigns.post("/campaigns", inputs);
  },
  enable(id, inputs) {
    return campaigns.put("/campaigns/" + id + "/enable", inputs);
  },
  getCampSubs(id, qstr){
    qstr = fx.urlQueryString(qstr, false);
    return campaigns.get(`/campaigns/ ${id}/subscriptions?${qstr}`);
  }
};
